<template>
  <div>
    <el-form ref="formData" :loading="loading" :model="formData" :rules="formRules" :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="救助限额" prop="helpQuota">
            <el-input :value="parseFloat(formData.helpQuota || 0).toFixed(2)" disabled size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="已申请救助金额" prop="useHelpAmount">
            <el-input :value="parseFloat(currentUseHelpAmount || 0).toFixed(2)" disabled size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="剩余救助金额" prop="remainingSum">
            <el-input :value="parseFloat(remainingSum || 0).toFixed(2)" disabled size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <ChapterHead :level="2">
        <span>发票类型：原件</span>
        <img src="/static/err-icon.png" style="width: 14px;">
        <span style="font-size: 12px; color: #C0C4CC;">发票类型为原件，在此填写</span>
      </ChapterHead>
      <el-row>
        <el-col :span="6">
          <el-form-item label="对应发票张数" prop="origBillCount">
            <el-input :value="formData.origBillCount == 0 ? 0 : (formData.origBillCount || '-')" disabled size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对应自付费用" prop="origSelfPayAmount">
            <el-input :value="formData.origSelfPayAmount || formData.origSelfPayAmount == 0 ? parseFloat(formData.origSelfPayAmount || 0).toFixed(2) : '-'" disabled size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助费用" prop="origHelpAmount">
            <el-input :value="formData.origHelpAmount || formData.origHelpAmount == 0 ? parseFloat(formData.origHelpAmount || 0).toFixed(2) : '-'" disabled size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="发票附件" prop="origAttachList">
            <FileUpload v-model="formData.origAttachList" :disabled="localReadOnly"></FileUpload>
          </el-form-item>
        </el-col>
      </el-row> -->
      <ChapterHead :level="2">
        <span>发票类型：复印件</span>
        <img src="/static/err-icon.png" style="width: 14px;">
        <span style="font-size: 12px; color: #C0C4CC;">发票类型为复印件，在此填写</span>
      </ChapterHead>
      <el-row>
        <el-col :span="6">
          <el-form-item label="对应发票张数" prop="copyBillCount">
            <el-input :value="formData.copyBillCount == 0 ? 0 : (formData.copyBillCount || '-')" disabled size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对应自付费用" prop="copySelfPayAmount">
            <el-input :value="formData.copySelfPayAmount || formData.copySelfPayAmount == 0 ? parseFloat(formData.copySelfPayAmount || 0).toFixed(2) : '-'" disabled size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助费用" prop="origHelpAmount">
            <el-input :value="formData.copyHelpAmount || formData.copyHelpAmount == 0 ? parseFloat(formData.copyHelpAmount || 0).toFixed(2) : '-'" disabled size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="发票附件" prop="copyAttachList">
            <FileUpload v-model="formData.copyAttachList" :disabled="localReadOnly"></FileUpload>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="6">
          <el-form-item label="住院号" prop="inHospitalNo">
            <el-input v-if="localReadOnly" :value="formData.inHospitalNo || '-'" disabled size="small" />
            <el-input v-else v-model="formData.inHospitalNo" :disabled="localReadOnly" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="总救助费用" prop="helpAmount">
            <el-input :value="formData.helpAmount ? parseFloat(formData.helpAmount || 0).toFixed(2) : '-'" disabled size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="formData.remark" :rows="3" :disabled="localReadOnly" size="small"/>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="治愈状态" prop="healState">
            <DictionarySelect v-model="formData.healState" :lazy="true" tableCode="HEAL_STATE" :disabled="localReadOnly"></DictionarySelect>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getOutlayDataById, saveCureOutlay, submitCureOutlay, saveNewOutlayAndStages, submitNewOutlayAndStages } from "@/util/api.js";
import ChapterHead from "@/components/business/ChapterHead";
import DictionarySelect from "@/components/business/DictionarySelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import FileUpload from "@/components/business/FileUpload";
import MoneyInput from "@/components/business/MoneyInput";
import NumberInput from "@/components/business/NumberInput";

export default {
  components: {
    ChapterHead,
    DictionarySelect,
    DiseaseCascader,
    FileUpload,
    MoneyInput,
    NumberInput
  },
  props: {
    outlayId: String,
    helpReqId: String,
    readOnly: false,
    addAngleStages: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      localReadOnly: true,
      currentUseHelpAmount: 0,
      currentHelpAmount: 0,
      currentRemaining: 0,
      formData: {},
      formRules: {
        healState: [{ required: true, message: '请选择治愈状态', trigger: 'change' }],
      },
      remainingSum: 0
    }
  },
  watch: {
    outlayId: {
      immediate: true,
      handler () {
        this.loadData()
      }
    }
  },
  methods: {
    loadData () {
      if (this.outlayId) {
        this.loading = true;
        getOutlayDataById(this.outlayId).then(res => {
          this.loading = false;
          if (res.msgCode == 200) {
            if (this.addAngleStages) {
              this.formData = {
                helpQuota: (res.responseData.helpQuota || 0) + (res.responseData.specialQuota || 0),
                useHelpAmount: (res.responseData.useHelpAmount || 0),
                outlayStatus: 0,
                helpReqId: this.helpReqId,
                helpAmount: this.addAngleStages ? 0 : (res.responseData.helpAmount || 0)
              };
            } else {
              this.formData = {
                ...res.responseData,
                helpQuota: (res.responseData.helpQuota || 0) + (res.responseData.specialQuota || 0),
                useHelpAmount: (res.responseData.useHelpAmount || 0),
                origHelpAmount: (res.responseData.origHelpAmount || 0),
                copyHelpAmount: (res.responseData.copyHelpAmount || 0),
                helpAmount: this.addAngleStages ? 0 : (res.responseData.helpAmount || 0)
              };
            }
            this.currentHelpAmount = (res.responseData.helpAmount || 0);
            this.currentUseHelpAmount = (parseFloat(res.responseData.useHelpAmount || 0) + parseFloat(this.currentHelpAmount));
            // if (this.addAngleStages) {
            //   this.currentRemaining = (parseFloat(res.responseData.helpQuota || 0) - this.currentUseHelpAmount)
            // }
            this.remainingSum = (parseFloat(this.formData.helpQuota || 0) - parseFloat(this.currentUseHelpAmount || 0));
            this.localReadOnly = this.readOnly || [0, 2].indexOf(this.formData.outlayStatus) < 0;
            this.$emit('onload', this.formData);
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.localReadOnly = true;
      }
    },
    calcOrigOutlay () {
      let useAmount = parseFloat(this.formData.useHelpAmount || 0) + parseFloat(this.formData.copyHelpAmount || 0);
      let maxAmount = this.addAngleStages ? this.currentRemaining : parseFloat(this.formData.helpQuota || 0) - useAmount;

      if (parseFloat(this.formData.origSelfPayAmount || 0) < maxAmount) {
        this.formData.origHelpAmount = parseFloat(this.formData.origSelfPayAmount || 0);
      } else {
        this.formData.origHelpAmount = (maxAmount);
      }
      this.calcTotalOutlay();
    },
    calcCopyOutlay () {
      let useAmount = parseFloat(this.formData.useHelpAmount || 0) + parseFloat(this.formData.origHelpAmount || 0);
      let maxAmount = this.addAngleStages ? this.currentRemaining : parseFloat(this.formData.helpQuota || 0) - useAmount;

      if (parseFloat(this.formData.copySelfPayAmount || 0) < maxAmount) {
        this.formData.copyHelpAmount = parseFloat(this.formData.copySelfPayAmount || 0);
      } else {
        this.formData.copyHelpAmount = (maxAmount);
      }
      this.calcTotalOutlay();
    },
    calcUseHelpAmount () {
      // if (this.addAngleStages) {
      //   this.currentUseHelpAmount = (parseFloat(this.formData.useHelpAmount || 0) + this.currentHelpAmount + parseFloat(this.formData.helpAmount || 0));
      // } else {
        this.currentUseHelpAmount = (parseFloat(this.formData.useHelpAmount || 0) + parseFloat(this.formData.helpAmount || 0));
      // }
      this.remainingSum = (parseFloat(this.formData.helpQuota || 0) - parseFloat(this.currentUseHelpAmount || 0));
    },
    calcTotalOutlay () {
      this.formData.selfPayAmount = (parseFloat(this.formData.origSelfPayAmount || 0) + parseFloat(this.formData.copySelfPayAmount || 0));
      this.formData.helpAmount = (parseFloat(this.formData.origHelpAmount || 0) + parseFloat(this.formData.copyHelpAmount || 0));
      this.calcUseHelpAmount();
    },
    saveData () {
      this.loading = true;
      let params = this.getParams();
      let request = null;
      if (this.addAngleStages) {
        params.belongProject = 'AY1002';
        params.outlayType = 1;
        params.outlayStatus = 0;
        request = saveNewOutlayAndStages(params);
      } else {
        request = saveCureOutlay(params);
      }
      request.then(res => {
        this.loading = false;
        if (res.msgCode == 200) {
          this.$message.success('暂存成功！');
          this.$emit('success', this.formData);
        } else {
          this.$message.error(res.msg)
        }
        this.$emit('complete', this.formData);
      })
    },
    submitData () {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = this.getParams();
          let request = null;
          if (this.addAngleStages) {
            params.belongProject = 'AY1002';
            params.outlayType = 1;
            params.outlayStatus = 1;
            request = submitNewOutlayAndStages(params);
          } else {
            request = submitCureOutlay(params);
          }
          request.then(res => {
            this.loading = false;
            if (res.msgCode == 200) {
              this.$message.success('提交成功！');
              this.$emit('success', this.formData);
            } else {
              this.$message.error(res.msg)
            }
            this.$emit('complete', this.formData);
          })
        }
      });
    },
    getParams () {
      let params = {
        helpReqId: this.helpReqId,
        ...this.formData
      };
      if (!this.addAngleStages) {
        delete params.helpQuota;
        delete params.specialQuota;
      }
      return params;
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../../common/form.scss';
</style>


// WEBPACK FOOTER //
// src/pages/outlay/view/CureOutlayTsForm.vue